import { api } from './apiClient';

export const fetchSupportChatsList = async (
  page = 1,
  pageSize = 20,
  searchtext = '',
  startDate = '',
  endDate = ''
) => {
  try {
    const requestBody = {
      pagination: {
        page,
        pageSize,
        sort: { last_message_at: -1 },
      },
      searchtext: searchtext || '',
      startDate: startDate || '',
      endDate: endDate || '',
    };

    const response = await api.post('/api/v1/admin/support-chats/list', requestBody);
    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    }
    throw new Error(error.message || 'An unexpected error occurred');
  }
};

export const fetchSupportChatRoom = async (chatId) => {
  if (!chatId) {
    throw new Error('Chat room ID is required');
  }

  try {
    const response = await api.get(`/api/v1/admin/support-chats/${chatId}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    }
    throw new Error(error.message || 'An unexpected error occurred');
  }
};

export const sendSupportChatMessage = async (
  chatId,
  { text = '', fileUrls = [], type = '' } = {}
) => {
  if (!chatId) {
    throw new Error('Chat room ID is required');
  }

  const normalizedText = typeof text === 'string' ? text.trim() : '';
  const normalizedFileUrls = Array.isArray(fileUrls)
    ? fileUrls.filter((url) => typeof url === 'string' && url.trim())
    : [];

  if (!normalizedText && normalizedFileUrls.length === 0) {
    throw new Error('Message text or image is required');
  }

  const requestBody = {
    text: normalizedText,
    fileUrls: normalizedFileUrls,
    type: type || (normalizedFileUrls.length > 0 ? 'image' : 'text'),
  };

  try {
    const response = await api.post(
      `/api/v1/admin/support-chats/${chatId}/message`,
      requestBody
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    }
    throw new Error(error.message || 'An unexpected error occurred');
  }
};
